/* eslint-disable camelcase -- GA4 event parameter names use snake_case. */
import registry from '@/data/site-registry.json';
import { sendVisitorMetric } from './visitor-metrics';

export function analyticsEnabled() {
	return (
		typeof window !== 'undefined' &&
		process.env.REACT_APP_ENV === 'PRODUCTION' &&
		['mrdevello.com', 'www.mrdevello.com'].includes(
			window.location.hostname
		) &&
		registry.pages.some((page) => page.path === window.location.pathname)
	);
}

// Callers supply only stable registry/DOM IDs and sanitized page metadata.
export function sendAnalytics(event: string, params: Record<string, string>) {
	if (!analyticsEnabled()) return;
	sendVisitorMetric(event, params);
	const target = window as unknown as {
		gtag?: (...args: unknown[]) => void;
		dataLayer?: unknown[];
	};
	if (!target.gtag) {
		target.dataLayer = target.dataLayer || [];
		target.gtag = function () {
			target.dataLayer?.push(arguments);
		};
		target.gtag('js', new Date());
		target.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
			send_page_view: false,
			page_location: window.location.origin + window.location.pathname,
			page_referrer: ''
		});
		const script = document.createElement('script');
		script.async = true;
		script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA_MEASUREMENT_ID}`;
		document.head.appendChild(script);
	}
	target.gtag('event', event, {
		page_location: registry.siteUrl + window.location.pathname,
		page_title: document.title,
		...params,
		send_to: process.env.REACT_APP_GA_MEASUREMENT_ID
	});
}

// Never include form values, contact details or inquiry text in analytics.
export function trackLead() {
	const page = registry.pages.find(
		(item) => item.path === window.location.pathname
	);
	if (page)
		sendAnalytics('generate_lead', {
			form_id: 'project_inquiry',
			method: 'website',
			page_id: page.id
		});
}
